import { useEffect, useState } from 'react'
import { NVButton } from '@nv/basic-components'
import { AuthCodeInput } from '@nv/components'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './SecurityQuestion.module.scss'
import '@djthoms/pretty-checkbox'

const SecurityQuestion = ({ view, onSubmit, code, setCode }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [codeError, setCodeError] = useState(false)

  useEffect(() => {
    setCodeError(false)

    if (code.length === 4) {
      const handleSubmit = async () => {
        const result = await onSubmit()
        if (!result?.success) setCodeError(true)
      }

      handleSubmit()
    }
  }, [code])

  return (
    <div className={styles['container']}>
      <div className={styles['body']}>
        <span className={styles['title']}>
          {t('auth.login.last4Digits')}
          <span className={clsx(styles['title'], styles['title--primary-bold'])}> {t('form.labels.cellNumber')}</span>
        </span>

        <AuthCodeInput code={code} setCode={setCode} length={4} codeError={codeError} />
      </div>

      <div className={styles['footer']}>
        {view === 'MyAccount' && (
          <NVButton
            classes={{ container: styles['footer__cancel-btn'] }}
            view='secondary'
            text={t('buttons.cancel')}
            height={50}
            onClick={() => navigate('/voting/voter/my-account')}
          />
        )}

        {/* <NVButton text={t('buttons.next')} height={50} disabled={notValid} onClick={onSubmit} /> */}
      </div>
    </div>
  )
}

export default SecurityQuestion
